module.exports = __webpack_public_path__ + "static/media/exploretech_la_2022_Multimedia_Release_Form.267b9baa.pdf";